module.exports = __webpack_public_path__ + "media/images/Icon-error-116860c77bfe6d76665c2c4fc7f869f6.svg";